import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .section {
    border-radius: 8px;
    padding: 2rem;
    margin-bottom: 3rem;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

    h1 {
      font-size: 40px;
      margin-bottom: 16px;
      font-weight: 700;
      border-left: 4px solid ${({ theme }) => theme.colors.primary.main};
      padding-left: 8px;
    }

    h2 {
      font-size: 28px;
      font-weight: 700;
      margin-bottom: 16px;
    }

    p {
      font-size: 20px;
      line-height: 135%;
      padding-left: 8px;
    }
  }
`;
